import { Fragment } from 'react';
import DateTime from 'common/components/DateTime/DateTime';

import {
    FormSection,
} from 'forms/components/common';

const DateField = (field) => {
    return <DateTime
        value={field.value}
        time={false}
        applyTimezoneOffset={false}
        isUTC={true}
        format={'DD MMM YYYY'}
    />;
};

const TextField = (field) => {
    return field.value;
};

const UserField = (field) => {
    return field.value;
};

const ViewToComponentMap = {
    'DatePicker': DateField,
    'SingleSelect': TextField,
    'User': UserField,
    'ShortText': TextField,
};

function CustomEventDetails(props) {
    const getEventTypeFields = (event) => {
        const fields = event.fields.filter(field => field.name !== 'editNote');
        const eventFieldComponents = fields.map(field => {
            const viewComponent = ViewToComponentMap[field.view];
            const view = viewComponent(field);

            return <FormSection key={field.name} headerText={field.displayName} data-cy={'CustomEventDetails' + field.name}>
                {view}
            </FormSection>;
        });

        return eventFieldComponents;
    };

    const { signatureRequest } = props;
    const eventTypeFields = getEventTypeFields(signatureRequest.customEvent);
    return (
        <Fragment data-cy="CustomEventDetails-return">
            <FormSection headerText="Binder">
                {signatureRequest.binderName}
            </FormSection>
            <FormSection headerText="From">
                {signatureRequest.createdBy.displayName}
            </FormSection>
            <FormSection headerText="Sent Date">
                <DateTime value={signatureRequest.sentDate} time={false} format={'MMM DD, YYYY'}/>
            </FormSection>
            <FormSection headerText="Event Type">
                {signatureRequest.customEvent.eventType.displayName}
            </FormSection>

            {eventTypeFields}

            <FormSection headerText="Statement of Testament">
                I approve the details of this Event
            </FormSection>
        </Fragment>
    );
}

export default CustomEventDetails;
